import { RegistrationField, TextValueOption } from '../interfaces/interfaces';

interface LimitedValue {
  _id: string;
  value: string;
  count: number;
}

export function useLimitedRegistrationField() {
  function getCountForOption(field: RegistrationField, currentTvo: TextValueOption, limitedValuesCount: LimitedValue[] = []) {
    return limitedValuesCount?.find((f) => f._id === field._id && currentTvo.content === f.value)?.count ?? 0;
  }

  function isFieldOptionDisabled(field: RegistrationField, currentTvo: TextValueOption, limitedValuesCount: LimitedValue[] = []) {
    if (field.fieldType !== 'limited') return false;

    const _limit = currentTvo.limit ?? 0;
    const _limitedField = getCountForOption(field, currentTvo, limitedValuesCount);
    if (!_limitedField) return false;

    const _count = _limitedField ?? 0;
    return _count >= _limit;

    /**  
     * Limited Multi Select is not supported in this version - therefore we have removed this here.
		 * const _limitedField = limitedValuesCount?.filter((f) => field._id === f._id);
      if (!_limitedField || _limitedField?.length === 0)
        return (
          <MenuItem key={tvo.content} value={tvo.content}>
            {ct(tvo.content, tvo)}
          </MenuItem>
        );
      let _count = 0;
      for (const lf of _limitedField) {
        const values = lf.value?.split(',') ?? [];
        if (values.includes(tvo.content)) _count += lf.count;
      }
      disabled = _count >= _limit;
		 */
  }

  return {
    isFieldOptionDisabled,
    getCountForOption,
  };
}
